import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray, reduxForm, formValueSelector } from 'redux-form';
import * as validators from 'utils/validators';
import InputField from 'components/InputField';
import { connect } from 'react-redux';
import * as actions from 'modules/account';
import { injectIntl } from 'react-intl';
import CollapsablePanel from './CollapsePanel';
import TextAreaField from 'components/TextAreaField';
import Locations from './Locations';
import ConfirmForm from './ConfirmForm';
import { canUseFeature } from '../../config/pricing';

class ProfileForm extends ConfirmForm {

    componentDidMount() {
        if (typeof window !== "undefined") {
            let windowEl = (function () {
                var isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");
                function scroll() {
                    return { left: scrollLeft, top: scrollTop };
                };
                function scrollLeft() {
                    return window.scrollX || window.pageXOffset || (isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft);
                };
                function scrollTop() {
                    return window.scrollY || window.pageYOffset || (isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop);
                };
                return {
                    scroll: scroll,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop
                }
            })();

            let handle = setInterval(() => {
                let scrollY = windowEl.scrollTop();
                if (scrollY !== 0)
                    window && window.scrollTo(0, 0);
                else clearInterval(handle);

            }, 800);
        }
    }

    render() {
        let { initialValues, pristine, submitting, handleSubmit, onSubmit, submitFailed, dispatch, valid, hasMultipleLocations, locations, profile, intl } = this.props;
        const t = (id) => intl.formatMessage({ id });

        initialValues.styles = initialValues.styles || {};

        let disabled = pristine || submitting || initialValues.reverting;
        let hasChanges = !disabled;
        let isFreePlan = !canUseFeature(profile.profile && profile.profile.subscription, 'shippingLabels');

        return (<div>
            <style>{`
      
            textarea{
                font-size:10px;
                font-family:Consolas,Monaco,Lucida Console,Liberation Mono,DejaVu Sans Mono,Bitstream Vera Sans Mono,Courier New;
                background-color: beige;
                border: none;
            }
            
            `}</style>

            {isFreePlan ?
                <div className="panel panel-danger">
                    <h4>{t('labels.glsRequiresPro')}</h4>
                    <p>{t('labels.upgradeDesc')}</p>
                    <button className="btn btn-success" onClick={() => { window ? window.location.href = 'billing' : () => { } }}>{t('labels.upgradePlan')}</button>
                </div>
                : <div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="container-fluid">


                            {!hasMultipleLocations && <div>


                                <div className="row"><div className="col-md-6 col-sm-12">
                                    <CollapsablePanel location="default" section="gls" title={t('labels.eeuGls')}>
                                        <div className="form-group">
                                            <div className="checkbox">
                                                <label htmlFor="gls.enabled"><Field parse={value => !!value} name="gls.enabled" id="gls.enabled" component="input" type="checkbox" />{t('labels.enabled')}</label>
                                            </div>
                                        </div>
                                        {profile.gls && profile.gls.enabled && <div>


                                            <div className="form-group">
                                                <label htmlFor="gls.sender_country">{t('labels.country')}</label>


                                                <Field className="form-control" name="gls.sender_country" component="select">
                                                    <option value="HU">{t('labels.hungary')}</option>
                                                    <option value="SK">{t('labels.slovakia')}</option>
                                                    <option value="CZ">{t('labels.czech')}</option>
                                                    <option value="RO">{t('labels.romania')}</option>
                                                    <option value="SI">{t('labels.slovenia')}</option>
                                                    <option value="HR">{t('labels.croatia')}</option>
                                                </Field>

                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="gls.senderid">{t('labels.senderId')}</label>

                                                <Field
                                                    className="form-control"
                                                    name="gls.senderid"
                                                    component={InputField}
                                                    type="text"
                                                    validate={[validators.required]}
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="gls.username">{t('labels.username')}</label>

                                                <Field
                                                    className="form-control"
                                                    name="gls.username"
                                                    component={InputField}
                                                    type="text"
                                                    validate={[validators.required]}
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="gls.password">{t('labels.password')}</label>

                                                <Field
                                                    className="form-control"
                                                    name="gls.password"
                                                    component={InputField}
                                                    type="password"
                                                    validate={[validators.required]}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="gls.sender_name">{t('labels.name')}</label>

                                                <Field
                                                    className="form-control"
                                                    name="gls.sender_name"
                                                    component={InputField}
                                                    type="text"
                                                    validate={[validators.required]}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="gls.sender_city">{t('labels.city')}</label>

                                                <Field
                                                    className="form-control"
                                                    name="gls.sender_city"
                                                    component={InputField}
                                                    type="text"
                                                    validate={[validators.required]}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="gls.sender_address">{t('labels.address')}</label>

                                                <Field
                                                    className="form-control"
                                                    name="gls.sender_address"
                                                    component={InputField}
                                                    type="text"
                                                    validate={[validators.required]}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="gls.sender_zipcode">{t('labels.zipCode')}</label>

                                                <Field
                                                    className="form-control"
                                                    name="gls.sender_zipcode"
                                                    component={InputField}
                                                    type="text"
                                                    validate={[validators.required]}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="gls.sender_contact">{t('labels.contactPerson')}</label>

                                                <Field
                                                    className="form-control"
                                                    name="gls.sender_contact"
                                                    component={InputField}
                                                    type="text"
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="gls.sender_phone">{t('labels.phone')}</label>

                                                <Field
                                                    className="form-control"
                                                    name="gls.sender_phone"
                                                    component={InputField}
                                                    type="text"
                                                    validate={[validators.required]}
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="gls.sender_email">{t('labels.email')}</label>

                                                <Field
                                                    className="form-control"
                                                    name="gls.sender_email"
                                                    component={InputField}
                                                    type="text"
                                                    validate={[validators.required, validators.email]}
                                                />
                                            </div>

                                            <h2>{t('labels.glsServices')}</h2>
                                            <div className="form-group">
                                                <div className="checkbox">
                                                    <label htmlFor="gls.services.T12.enabled">
                                                        <Field
                                                            parse={value => !!value} name="gls.services.T12.enabled" id="gls.services.T12.enabled" component="input" type="checkbox" />{t('labels.expressService')} </label>
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <div className="checkbox">
                                                    <label htmlFor="gls.services.XS.enabled"><Field parse={value => !!value} name="gls.services.XS.enabled" id="gls.services.XS.enabled" component="input" type="checkbox" />{t('labels.exchangeService')}</label>
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <div className="checkbox">
                                                    <label htmlFor="gls.services.SM1.enabled"><Field parse={value => !!value} name="gls.services.SM1.enabled" id="gls.services.SM1.enabled" component="input" type="checkbox" />{t('labels.smsService')}</label>
                                                </div>
                                            </div>
                                            {profile.gls && profile.gls.services && profile.gls.services.SM1 && profile.gls.services.SM1.enabled && <div className="form-group">
                                                <label htmlFor="gls.services.SM1.text">{t('labels.smsText')}</label>

                                                <Field
                                                    className="form-control"
                                                    name="gls.services.SM1.text"
                                                    component={TextAreaField}
                                                    type="text"
                                                    validate={[validators.required]}
                                                />
                                            </div>}
                                            <div className="form-group">
                                                <div className="checkbox">
                                                    <label htmlFor="gls.services.SM2.enabled"><Field parse={value => !!value} name="gls.services.SM2.enabled" id="gls.services.SM2.enabled" component="input" type="checkbox" />{t('labels.preAdviceService')}</label>
                                                </div>
                                            </div>
                                        </div>}
                                    </CollapsablePanel>

                                </div>
                                </div>
                            </div>
                            }

                            {hasMultipleLocations && canUseFeature(profile.profile && profile.profile.subscription, 'shippingLabels') && <div className="form-group">
                                <FieldArray name="locations" user={initialValues} showLabels={true} locations={locations || []} dispatch={dispatch} component={Locations} />
                            </div>}

                        </div>


                        <br />
                        <div className={pristine ? "save-panel" : "save-panel visible"}>{t('labels.unsavedChanges')}</div>
                        {!pristine && <button type="button" onClick={() => location.reload()} className="discard-changes-button btn btn-default btn-sm">{t('labels.discard')}</button>}
                        <button id="save-changes" style={{
                            position: 'fixed',
                            top: '10px',
                            right: '10px',
                            zIndex: '99999999',
                            opacity: pristine ? 0 : 1
                        }}
                            className="btn btn-success btn-sm"
                            type="submit"
                            title={(!pristine || submitFailed) && !valid ? "Form has invalid fields, check if all required fields are filled" : t('labels.save')}
                            disabled={pristine || submitting || initialValues.reverting} >
                            <i className="fa fa-check"></i>&nbsp;{t('labels.save')}
                </button>
                        <i style={{
                            position: 'fixed',
                            top: '20px',
                            left: '13px',
                            zIndex: '999',
                            fontSize: '23px',
                            color: 'white'

                        }} onClick={() => {
                            window.location.href = '/' + this.props.intl.locale + '/dashboard';
                        }
                        } className="back-button fa fa-arrow-circle-left">&nbsp;</i>
                    </form>

                </div>}



        </div>);
    }
}


ProfileForm.PropTypes = {
    onSubmit: PropTypes.func.isRequired,
}

let ProfileFormComponent = reduxForm({ form: "Profile" })(injectIntl(ProfileForm));
ProfileFormComponent = connect(state => {
    const connectors = selector(state, 'connectors');
    const accounting = selector(state, 'accounting');
    const taxes = selector(state, 'taxes');
    const hasMultipleLocations = selector(state, 'hasMultipleLocations');
    const locations = selector(state, 'locations');
    const themes = selector(state, 'themes');

    const currentInvoiceDate = selector(state, 'currentInvoiceDate');
    return {
        connectors,
        accounting,
        currentInvoiceDate,
        hasMultipleLocations,
        locations,
        themes,
        taxes
    }
})(ProfileFormComponent)
const selector = formValueSelector('Profile');

class Profile extends Component {
    constructor(props) {
        super(props);

    }

    componentDidMount() {
        let { dispatch } = this.props;

        dispatch(actions.fetchAccount());
    }

    onSubmit(account) {
        let { dispatch } = this.props;
        dispatch(actions.updateAccount(account));
    }
    render() {

        let { account, intl, profile } = this.props;

        if (!account || !account.email) {
            return <div style={{
                position: 'absolute',
                top: '0',
                left: '50%'
            }}>{intl.formatMessage({ id: 'common.loading' })}</div>
        }

        return <div className="container-fluid">
            <div className="sidebar">
                <div className="col-md-10">
                    <span style={{ marginLeft: '23px' }}>{intl.formatMessage({ id: 'labels.title' })}</span>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 col-lg-12 col-xs-12">

                    <ProfileFormComponent onSubmit={this.onSubmit.bind(this)} initialValues={account} profile={profile} />

                </div>
            </div>
        </div>

    }
}

Profile.propTypes = {
    account: PropTypes.object,
    dispatch: PropTypes.func.isRequired
};

function mapStateToProps(state) {

    return {
        ...state.user,
        account: {
            ...state.account
        },
        profile: state.form.Profile ? state.form.Profile.values : {},
    };
}

export default injectIntl(connect(mapStateToProps)(Profile));




// WEBPACK FOOTER //
// app/containers/Labels.jsx